import { defineMessages } from 'react-intl'

const landingComposerMessages = defineMessages({
  tryExample: {
    id: 'qP3Z_j9Jge4LHfIL4GGN',
    defaultMessage: 'Try: {example}',
    description: 'Prompt in the empty TripPlanner landing chat input suggesting an example request. Shown with the example sliding in and out, and read by screen readers as the input placeholder',
  },
})

export default landingComposerMessages
